<mat-toolbar color="primary">
  <mat-toolbar-row>
    <button mat-icon-button>
      <mat-icon (click)="sidenav.toggle()">menu</mat-icon>
    </button>
    <h1>TobiMap</h1>
    <span class="header-spacer"></span>
    <button mat-icon-button>
      <mat-icon (click)="openInfoPage()">info</mat-icon>  
    </button>
  </mat-toolbar-row>
</mat-toolbar>
<mat-sidenav-container>
  <mat-sidenav mode="side" #sidenav opened>
    <mat-nav-list
      cdkDropList
      #mapPointList="cdkDropList"
      [cdkDropListData]="mapPoints"
      (cdkDropListDropped)="replaceMapPointList($event)"
    >
      <a
        mat-list-item
        routerLink="."
        *ngFor="let point of mapPoints"
        [cdkDragData]="point"
        (click)="moveCenterToClickedPoint(point)"
        cdkDrag
      >
        <span class="badge">{{ point.order }}</span> 
        <span class='point-name' [attr.data-test]="'point-list'">{{ point.name }}</span>  
      </a>
    </mat-nav-list>
  </mat-sidenav>
  <mat-sidenav-content>
    <app-content></app-content>
  </mat-sidenav-content>
</mat-sidenav-container>
